import React from 'react';

import {useUserRoleFunctions} from 'shared/hooks/use-user-role-functions';
import {EDocStatusCodes} from 'shared/types/files';
import {EUserRoleFunction} from 'store/slices/user-slice/user-slice-role-functions';

import {EditableField, IEditableFieldProps} from '../editable-field/editable-field';

export interface IReportLinkFieldProps extends IEditableFieldProps {
    record: any;
}

// Обертка над EditableField; используется для отображения ссылки только в случае наличия отчета jasperReport
// или portalReport(он же tableReport)
export const ReportLinkField = (props: IReportLinkFieldProps) => {
    const {value, record, entityName} = props;

    const {
        hasUserRoleFunction,
    } = useUserRoleFunctions({sections: [entityName]});

    return (
        <EditableField
            {...props}
            reportType={value?.documentType?.reportTypeCode}
            editProperties={{
                hide: record.docStatusCode === EDocStatusCodes.PUBLISHED,
                disable: !hasUserRoleFunction(EUserRoleFunction.CREATE),
            }}
        />
    );
};
